import { useContext, useEffect, useState } from "react";
import { Table, Row, Col, Tabs } from "antd";
import { Context } from "../../context";
import { Fetch } from "../../fetch";
import { convertIdToKey } from "../../utils";

const { Column } = Table;
const { TabPane } = Tabs;

const LikeReports = () => {
  const { token, apiUrl } = useContext(Context);

  const [activeTab, setActiveTab] = useState("1");
  const [data, setData] = useState([]);

  useEffect(() => {
    Fetch(`${apiUrl}/reports/likes_dislikes`, token, (result) => {
      const likes = convertIdToKey(result.data);
      setData(likes);
    });
  }, [apiUrl, token]);

  return (
    <div className="manage-orders-wrapper">
      <>
        <Tabs
          defaultActiveKey="1"
          activeKey={activeTab}
          onChange={(v) => setActiveTab(v)}
        >
          <TabPane tab="Likes Report" key="1">
            <Row style={{ marginBottom: "20px" }} align={"middle"}>
              <Col span={4}></Col>
            </Row>
            <Table dataSource={data} pagination={false}>
              <Column
                title="Content Title"
                dataIndex="content_title"
                key="content_title"
                align="center"
              />
              <Column
                title="Like count"
                dataIndex="likes"
                key="likes"
                align="center"
                render={(_, v) => (v.likes ? v.likes : 0)}
              />
              <Column
                title="Dislike count"
                dataIndex="dislikes"
                key="dislikes"
                align="center"
                render={(_, v) => (v.dislikes ? v.dislikes : 0)}
              />
            </Table>
          </TabPane>
        </Tabs>
      </>
    </div>
  );
};

export default LikeReports;
